module.exports = __webpack_public_path__ + "img/Simple-Line-Icons.73a93256.svg";